// extracted by mini-css-extract-plugin
export default {"center":"Loader_center__Pik31","wave":"Loader_wave__joLUV"};